import React from 'react'
import PreliminaryForm from './preliminaryBinocularTests/Preliminary';
import BinocularForm from './preliminaryBinocularTests/Binocular';

export default function PreliminaryBinocularForm(props) {
  return (
    <div className="row">
      <PreliminaryForm {...props} />
      <BinocularForm {...props} />
    </div>
  )
}